import { ApiError } from '~shared/util/fetchUtil'
import { KdsApiErrorCode } from '../Types/Enums'

export function isDeviceRevokedError(error: unknown): boolean {
  if (!(error instanceof ApiError) || error.status !== 401) {
    return false
  }
  const body = error.body as { ErrorCode?: string } | null
  return body?.ErrorCode === KdsApiErrorCode.DeviceRevoked
}
